<template>
  <div>
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="商人ID"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.uid"
        class="param-input"
        @keyup.enter.native="JushangList('status')"
      ></el-input>
      <el-input
        placeholder="账号"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.name"
        class="param-input"
        @keyup.enter.native="JushangList('status')"
      ></el-input>
      <!-- <el-input
        placeholder="操作人员"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.operator"
        class="param-input"
        @keyup.enter.native="JushangList('status')"
      ></el-input> -->
       <!-- <el-input
        placeholder="用户ID"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.customerId"
        class="param-input"
        @keyup.enter.native="JushangList('status')"
      ></el-input>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker> -->
      <el-button type="primary" size="mini" @click="JushangList('status')">搜索</el-button>
    </div>

        <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%" height='620' v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
       <el-table-column prop="uid" label="商人ID" fixed align="center" :show-overflow-tooltip="true" min-width="110">
        <template slot-scope="scope">
          <span>{{scope.row.uid }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="账号" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="昵称" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.nickName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作人员" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.operator }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="customerId" label="用户ID" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.customerId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="typeDesc" label="操作类型描述" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.typeDesc }}</span>
        </template>
      </el-table-column>
            <el-table-column prop="type" label="操作类型" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.type }}</span>
        </template>
      </el-table-column>
            <el-table-column prop="desc" label="记录描述" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.desc }}</span>
        </template>
      </el-table-column>
            <el-table-column prop="amount" label="变动金额(元)" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="newBalance" label="商人账户余额(元)/本次更新" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.newBalance }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="originBalance" label="商人账户余额(元)/上次更新" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.originBalance }}</span>
        </template>
      </el-table-column>      
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt  | changeDate}}</span>
        </template>
      </el-table-column>      
          </el-table>
     <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="form.pageNumber" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 1" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
  </div>
</template>

<script>
import API from '@/api'
import { changeTime } from "@/utils/global";
export default {
 data() {
    return {
      loading: false,
      // 列表数据
      tableData: [],
      total: '',
      // time: '',
      // 请求列表数据参数
      form: {
        pageNumber: 1,
        pageSize: 10,
        uid:undefined,
        name:undefined,
        // customerId:undefined,
        nickName:undefined,
        operator:undefined,
        newBalance:undefined,
        originBalance:undefined,
      }
    }
  },
  created() {
    this.JushangList()
  },
  methods: {
    handleClear(type){
      this.form[type]= undefined
      this.JushangList('status')
    },
    JushangList(type) {
      if(type === 'status') {
        this.pageNumber = 1
      }
      this.loading = true
      API.JushangList(this.form).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
        // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.form.startTime = changeTime(time[0]);
        this.form.endTime = changeTime(time[1]);
      } else {
        this.form.startTime = "";
        this.form.endTime = "";
      }
      this.JushangList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.form.pageSize = size
      this.form.pageNumber = 1
      this.JushangList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.form.pageNumber = pageNumber
      this.JushangList()
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
